window.Vue.prototype.goto = function (href) {
    window.location.href = href;
};

window.Vue.prototype.confirmAction = function (message, method, path, params = {}) {
    if (!confirm(message)) return;
    let form = document.createElement("form");
    form.setAttribute("method", 'POST');
    form.setAttribute("action", path);

    params._token = document.head.querySelector('meta[name="csrf-token"]').content;
    params._method = method;

    for (let key in params) {
        if (params.hasOwnProperty(key)) {
            let hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);
            form.appendChild(hiddenField);
        }
    }
    document.body.appendChild(form);
    form.submit();
};

window.Vue.prototype.confirmDelete = function (message) {
    if (confirm(message)) {
        this.method = 'DELETE';
        Vue.nextTick(() => this.$refs.form.submit());
    }
};

window.Vue.prototype.confirmLink = function (message, $event) {
    if (confirm(message)) {
        window.location.href = $event.target.href;
    }
};

window.Vue.prototype.submit = function () {
    // this.$refs.form.action = action;
    Vue.nextTick(() => {
        if (this.$refs.form.checkValidity()) {
            this.$refs.form.submit()
        }
    });
};